"use strict";
import moment from "moment";
window.moment = moment;
import store from "../../modules/rankings/RankingFiltersStore";
import { bindShallow } from "../../uiMigration/bindAngularWithMobx";
import SelectedLocationsStore from "../../services/locations/SelectedLocationsStore";
import * as mobx from "mobx";

angular
  .module("clientDashboardApp")
  .controller("RankingCtrl", function (
    $scope,
    rankingService,
    pagingService,
    reactContainer
  ) {
    
    const reportType = reactContainer.getContainer().props.reportType;
    
    $scope.disabledDate = { after: new Date(moment().utc()) };
    
    $scope.searchConfig = {};
    
    $scope.getRankingOptions = function () {
      $scope.providers = $scope.searchConfig.rankingType === "web" ? $scope.webProviders : $scope.localProviders;
      return {
        groupId: $scope.searchConfig.groupId,
        startDate: $scope.searchConfig.startDate,
        endDate: $scope.searchConfig.endDate,
        providers: $scope.searchConfig.providers && $scope.searchConfig.providers.length ? $scope.searchConfig.providers.join() : [],
        reportType,
        rankingType: $scope.searchConfig.rankingType
      };
    };

    $scope.localArea = {};

    const searchDebounced = _.debounce(
      () => $scope.checkAndExecuteSearch(true),
      200
    );

    $scope.checkAndExecuteSearch = function (validForm) {
      if (!validForm) {
        return;
      }

      $scope.loadingResults = true;
      $scope.loadingTimeline = true;
      $scope.rankingReport = null;
      $scope.rankingTimeline = null;

      const rankingOptions = $scope.getRankingOptions();
      
      if (reportType === "avgRankings") {
        $scope.lowerScoreIsBetter = true;
      } else {
        $scope.lowerScoreIsBetter = false;
      }

      if (rankingOptions.providers.length) {
        $scope.reportProviders = rankingOptions.providers.split(",");
      } else {
        $scope.reportProviders = _.pluck($scope.providers, "id");
      }

      $scope.rankingOptions = rankingOptions;

      rankingService
        .rankingTable($scope.searchConfig.groupId, rankingOptions)
        .then(function (response) {
          updateRankingsTable(response);
          $scope.loadingResults = false;
        });
      rankingService
        .rankingsTimeline($scope.searchConfig.groupId, rankingOptions)
        .then(function (response) {
          updateRankingsTimeline(response);
          $scope.loadingTimeline = false;
        });
    };

    bindWithMobx();
    $scope.webProviders = store.getProviders("web");
    $scope.localProviders = store.getProviders("local");

    $scope.$watch(
      function () {
        return $scope.searchConfig;
      },
      function () {
        searchDebounced();
      }
    );

    function bindWithMobx() {
      bindShallow($scope, $scope.searchConfig, store.state, { debug: false, initializeFromMobx: true });

      $scope.$on(
        "$destroy",
        mobx.reaction(
          () => SelectedLocationsStore.legacyGroupIdOrAll,
          function(groupId) {
            $scope.searchConfig.groupId = groupId
          },
          {
            fireImmediately: true,
          }
        )
      );
    } // end bindWithMobx

    $scope.$on("$locationChangeSuccess", function (e) {
      searchDebounced();
    });

    /*
     * Rankings
     */
    //Default Sort Settings
    $scope.sortField = "keyword";
    $scope.reverseSortOrder = false;

    $scope.sortReportTable = function (newSortField) {
      if ($scope.sortField === newSortField) {
        $scope.reverseSortOrder = !$scope.reverseSortOrder;
      } else {
        $scope.sortField = newSortField;
      }
      $scope.pagedRankings.sortResults(
        $scope.sortField,
        $scope.reverseSortOrder
      );
    };

    $scope.getReportSortIcon = function (column) {
      if ($scope.sortField === column) {
        if ($scope.reverseSortOrder) {
          return "fa-sort-up";
        } else {
          return "fa-sort-down";
        }
      } else {
        return "fa-sort";
      }
    };

    const updateRankingsTable = function (rankingReport) {
      const rankingResult = rankingReport.results;
      _.each(rankingResult.latestResult, function (item) {
        $scope.localArea[item.keyword] = { expanded: false };
      });
      $scope.rankingResult = rankingReport;
      $scope.rankingReport = rankingResult;
      $scope.pagedRankings = pagingService.createPagingData(
        rankingResult.latestResult,
        50,
        $scope.sortField,
        $scope.reverseSortOrder
      );
      $scope.loadingResults = false;
    };

    const updateRankingsTimeline = function (rankingReport) {
      $scope.rankingTimeline = rankingReport.results;
      $scope.loadingTimeline = false;
    };

    $scope.allLocationsSelected = function () {
      return $scope.searchConfig.groupId.search(/^all/) == 0;
    };

    const getPreviousResult = function (keyword, providerId) {
      for (let i = 0; i < $scope.rankingReport.earliestResult.length; i++) {
        let ranking = $scope.rankingReport.earliestResult[i];
        if (
          ranking.keyword === keyword &&
          ranking.countByProvider[providerId]
        ) {
          return ranking.countByProvider[providerId];
        }
      }

      return null;
    };

    /**
     * props to be passed to MetricDelta component for average rankings (lower is better)
     */
    $scope.metricDeltaProps = function (ranking, provider) {
      const current = ranking.countByProvider[provider];
      const previous = getPreviousResult(ranking.keyword, provider);
      const hasBothRanks =
        (!!current || current === 0) &&
        (!!previous || previous === 0) &&
        !Number.isNaN(Number(current)) &&
        !Number.isNaN(Number(previous));
      const hasARank = hasBothRanks && (current !== 50 || previous !== 50);
      return {
        decimalDelta: hasARank ? (previous - current) / previous : undefined,
        showIcon: hasARank && current !== previous,
        showDeltaWithColor: true,
      };
    };

    /**
     * props to be passed to MetricDelta component for page 1 rankings (higher is better)
     */
    $scope.metricDeltaPropsPage1 = function (ranking, provider) {
      const current = ranking.countByProvider[provider];
      const previous = getPreviousResult(ranking.keyword, provider);
      const hasBothRanks =
        (!!current || current === 0) &&
        (!!previous || previous === 0) &&
        !Number.isNaN(Number(current)) &&
        !Number.isNaN(Number(previous));
      const hasARank = hasBothRanks && (current !== 0 || previous !== 0);
      return {
        decimalDelta: hasARank
          ? previous === 0
            ? 1
            : (current - previous) / previous
          : undefined,
        showIcon: hasARank && current !== previous,
        showDeltaWithColor: true,
      };
    };

    $scope.calculateChange = function (ranking, provider) {
      const newCount = ranking.countByProvider[provider];
      if (!angular.isDefined(newCount)) {
        return;
      }

      const oldCount = getPreviousResult(ranking.keyword, provider);
      if (!angular.isDefined(oldCount)) {
        return;
      }

      let change = Math.round((newCount / oldCount - 1) * 100);

      if ($scope.lowerScoreIsBetter) {
        change = change * -1;
      }
      if (change >= 0) {
        return change;
      } else if (change < 0) {
        return change * -1;
      }
    };

    $scope.getLocalAreaResults = function (ranking) {
      if (ranking.localAreas.length > 0) {
        const rankingOptions = $scope.getRankingOptions();
        rankingOptions.keyword = ranking.keyword;

        if (reportType === "avgRankings") {
          $scope.lowerScoreIsBetter = true;
        } else {
          $scope.lowerScoreIsBetter = false;
        }

        if (rankingOptions.providers && rankingOptions.providers.length) {
          $scope.reportProviders = rankingOptions.providers.split(",");
        } else {
          $scope.reportProviders = _.pluck($scope.providers, "id");
        }

        if (!$scope.localArea[ranking.keyword].data) {
          $scope.localArea[ranking.keyword].loading = true;
          rankingService
            .localAreaReport($scope.searchConfig.groupId, rankingOptions)
            .then(function (data) {
              $scope.localArea[ranking.keyword].loading = false;
              $scope.localArea[ranking.keyword].data = _.sortBy(
                data.results.latestResult,
                function (item) {
                  return item.localArea.toLowerCase();
                }
              );
              _.each($scope.localArea[ranking.keyword].data, function (item) {
                var providerKeys = [];
                _.each(item.countByProvider, function (val, key) {
                  providerKeys.push(key);
                });

                const justUnusedProviders = _.difference(
                  $scope.reportProviders,
                  providerKeys
                );
                _.each(justUnusedProviders, function (provider) {
                  item.countByProvider[provider] = "";
                });

                item.countByProviderPairs = _.sortBy(
                  _.pairs(item.countByProvider),
                  function (item) {
                    return item[0].toLowerCase();
                  }
                );
              });

              toggleExpander(ranking.keyword);
            });
        } else {
          toggleExpander(ranking.keyword);
        }
      }
    };

    $scope.selectAllProviders = () => {
      $scope.searchConfig.providers = _.map($scope.providers, (p) => p.id);
    };

    function toggleExpander(keyword) {
      $scope.localArea[keyword].expanded = !$scope.localArea[keyword].expanded;
    }
  });

angular.module("clientDashboardApp").directive("formatRank", [
  "$log",
  function ($log) {
    return {
      restrict: "A",
      scope: {
        rank: "=",
      },
      replace: true,
      template: "<span>{{formattedRank}}</span>",
      link: function (scope, elem, attrs, ctrl) {
        var maxRank = 50;
        if (scope.rank >= maxRank) {
          scope.formattedRank = ">" + maxRank;
        } else {
          scope.formattedRank = "" + scope.rank;
        }
      },
    };
  },
]);
